var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJmBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360.85 265.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7a9ac;stroke:#231f20;stroke-miterlimit:10;}.cls-2{fill:#231f20;}.cls-3{fill:#808285;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 360.85,
    height: 265.16,
    rx: 27.77,
    ry: 27.77
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.52,22.77h64.06L223,96.35l6.58,29.16H231l6.59-29.16L257,22.77h64.05V248.38h-52V195.27c0-26.72,5.12-88.16,8-114.54h-1.1l-20.13,67-12.45,41H215.66l-13.18-41-18.3-67h-1.47c2.93,26.38,8.06,87.82,8.06,114.54v53.11H139.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.63,215.4,43.1,178.27c12.76,14.57,26.91,22.9,40.71,22.9,19.32,0,30-7.63,30-36.09V72.75H28.6v-50H173.18V169.94c0,45.12-22.77,82.6-87.3,82.6C61,252.54,30.68,243.52,9.63,215.4Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJmBold);
export default __webpack_public_path__ + "static/media/jm-bold.92de93236f7ee6d65833a71b1981ffe1.svg";
export { ForwardRef as ReactComponent };